export default __webpack_public_path__ + "static/media/Landing-gmm2.556304c9.png";